import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Agencies } from 'app/models/agencies';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AgenciesService {
  base_path = 'https://app.titv-store-api.com/';
  
  constructor(private http: HttpClient) { }
  
  private refreshData = new Subject<void>();
  
  get refreshNeeded() {
    return this.refreshData;
  }
  
  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private getToken(): string {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        return userObj.token || '';
      }
      return '';
    } catch {
      return '';
    }
  }
  
  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private getHeaders(): HttpHeaders {
    const token = this.getToken();
    
    if (token) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      });
    }
    
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }
  
  // ✅ FIXED: Use arrow function to preserve 'this' context
  private handleError = (error: HttpErrorResponse) => {
    let errorMessage = 'Une erreur est survenue';
    
    if (error.status === 403) {
      errorMessage = `Accès interdit. Token: ${this.getToken() ? 'présent' : 'absent'}`;
    } else if (error.status === 401) {
      errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
    } else {
      errorMessage = `Erreur ${error.status}: ${error.message}`;
    }
    
    console.error('Erreur AgenciesService:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }
  
  // ✅ MÊME PATTERN QUE MAGAZINE SERVICE
  createItem(item: any): Observable<any> {
    const headers = this.getHeaders();
    
    return this.http.post(
      this.base_path + 'agencies/signupagency', 
      item,
      { headers, responseType: 'text' }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }
  
  // ✅ MÊME PATTERN QUE MAGAZINE SERVICE
  getItem(id: any): Observable<Agencies> {
    const headers = this.getHeaders();
    
    return this.http.get<Agencies>(
      this.base_path + 'agencies/' + id,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  // ✅ MÊME PATTERN QUE MAGAZINE SERVICE
  getAgencieById(idAgencie: number) {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'agencies/' + idAgencie,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  // ✅ MÊME PATTERN QUE MAGAZINE SERVICE
  getList(): Observable<Agencies> {
    const headers = this.getHeaders();
    
    return this.http.get<Agencies>(
      this.base_path + 'agencies/all',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  // ✅ MÊME PATTERN QUE MAGAZINE SERVICE
  updateItem(id: any, item: any): Observable<any> {
    const headers = this.getHeaders();
    
    return this.http.put(
      this.base_path + 'agencies/edit/' + id,
      item,
      { headers, responseType: 'text' }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }
  
  // ✅ MÊME PATTERN QUE MAGAZINE SERVICE
  deleteItem(id: any): Observable<any> {
    const headers = this.getHeaders();
    
    return this.http.delete(
      this.base_path + 'agencies/delete/' + id,
      { headers, responseType: 'text' }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }
  
  // ✅ MÊME PATTERN QUE MAGAZINE SERVICE POUR TOUTES LES MÉTHODES
  getListPromoteur(): Observable<Agencies> {
    const headers = this.getHeaders();
    
    return this.http.get<Agencies>(
      this.base_path + 'search/all/promoteurs',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListMateriaux(): Observable<Agencies> {
    const headers = this.getHeaders();
    
    return this.http.get<Agencies>(
      this.base_path + 'search/all/materials',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceImmob(): Observable<Agencies> {
    const headers = this.getHeaders();
    
    return this.http.get<Agencies>(
      this.base_path + 'search/all/agenceimmob',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceService(): Observable<Agencies> {
    const headers = this.getHeaders();
    
    return this.http.get<Agencies>(
      this.base_path + 'search/all/agenceservice',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getPromoteurParVille(ville: string) {
    const headers = this.getHeaders();
    
    return this.http.get(
      `${this.base_path}search/promoteurs/${ville}`,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getAgencieTunis() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/promoteurs/tunis',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getAgencieSousse() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/promoteurs/sousse',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getAgencieMonastir() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/promoteurs/monastir',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getAgencieMahdia() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/promoteurs/mahdia',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getAgencieSfax() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/promoteurs/sfax',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getAgencieNabeul() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/promoteurs/nabeul',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getAgencieBizerte() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/promoteurs/bizerte',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getAgencieTabarka() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/promoteurs/tabarka',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getAgencieDjerba() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/promoteurs/djerba',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceParVille(ville: string) {
    const headers = this.getHeaders();
    
    return this.http.get(
      `${this.base_path}search/agenceimmob/${ville}`,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceTunis() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceimmob/tunis',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceSousse() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceimmob/sousse',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceMonastir() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceimmob/monastir',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceMahdia() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceimmob/mahdia',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceSfax() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceimmob/sfax',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceNabeul() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceimmob/nabeul',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceBizete() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceimmob/bizerte',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAgenceDjerba() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceimmob/djerba',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListByType(type: string) {
    const headers = this.getHeaders();
    
    return this.http.get(
      `${this.base_path}search/agenceservice/${type}`,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListBanque() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceservice/banque',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListAssurances() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceservice/assurances',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListBureauxEtudes() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceservice/Bureauxdeetudes',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListLeasing() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceservice/leasing',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListServicesDivers() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceservice/servicesDivers',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListDecorations() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceservice/decorations',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListCommerces() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceservice/Commerces',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getListProDeAartisanat() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/agenceservice/ProDeAartisanat',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMateriauxParType(type: string) {
    const headers = this.getHeaders();
    
    return this.http.get(
      `${this.base_path}search/materials/${type}`,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMateriauxEquipement() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/materials/equipement',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMateriauxAutomatisme() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/materials/automatisme',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMateriauxChauffage() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/materials/chauffage',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMateriauxEnergie() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/materials/energie',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMateriauxMeuble() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/materials/meuble',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMateriauxProtection() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/materials/protection',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMateriauxMenuiserie() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/materials/menuiserie',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  getMateriauxDecoration() {
    const headers = this.getHeaders();
    
    return this.http.get(
      this.base_path + 'search/materials/decoration',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  idAgency: any;
  
  setIdAgency(id: any) {
    this.idAgency = id;
  }
  
  getIdAgency() {
    return this.idAgency;
  }
  
  private idSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  
  handleId(id: string | null): void {
    console.log('Handling ID in service:', id);
    this.idSubject.next(id);
  }
  
  getId(): Observable<string | null> {
    return this.idSubject.asObservable();
  }
}